import React from 'react';

export const Close = ({ color = '#F8F8FD' }: { color: string }) => (
  <svg width="100%" height="100%" viewBox="0 0 56 57" fill="none">
    <line x1="15.9784" y1="40.4411" x2="38.6059" y2="17.8137" stroke={color} strokeWidth="2" />
    <line x1="17.3934" y1="17.8136" x2="40.0208" y2="40.4411" stroke={color} strokeWidth="2" />
  </svg>
);
